import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SelectedSiteState {
  selectedSiteId: number;
}

const initialState: SelectedSiteState = {
  selectedSiteId: -1,
};

export const selectedSiteReducer = createSlice({
  name: "selectedSiteReducer",
  initialState,
  reducers: {
    setSelectedSiteId: (state, action: PayloadAction<number>) => {
      state.selectedSiteId = action.payload;
    },
  },
});

export const { setSelectedSiteId } = selectedSiteReducer.actions;
